import { compose, createStore, applyMiddleware } from "redux";
import rootReducer from "../reducers/index";

// allows you to write action creators that return a function instead of an action
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

// const preloadedState = {};
const enhancers = [];

// https://github.com/zalmoxisus/redux-devtools-extension
const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
if (typeof devToolsExtension === "function") {
  enhancers.push(
    devToolsExtension({
      trace: false, // if set to true, will include stack trace for every dispatched action
      traceLimit: 10,
      // Whitelist supercedes blacklist
      //   actionsBlacklist: [], // string or array of strings as regex - actions types to be hidden in the monitors
      //   actionsWhitelist: [], // string or array of strings as regex - actions types to be shown in the monitors
    })
  );
}

export const history = createBrowserHistory({ basename: `/` });
const middleware = [thunk, routerMiddleware(history)];

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(
  connectRouter(history)(rootReducer), // Root Reducer
  /* preloadedState, */
  composedEnhancers
);

export default store;
